<div class="content primary-back no-overflow" fxLayout>
  <img
    alt="Decoration"
    class="decoration position-top-right on-primary-low tint-white"
    src="../../../assets/images/RC_Logo_Icon.svg"
  />
  <mat-card class="mat-elevation-z7">
    <router-outlet></router-outlet>
  </mat-card>
</div>
